module.exports = __webpack_public_path__ + "img/HC2025-01.7e207841.jpg";